export default {"src":"/_next/static/media/proteinmini.51f9ee69.svg","height":125,"width":85,"blurWidth":0,"blurHeight":0};